import React from 'react';
import { FormattedMessage } from 'react-intl';
import ServiceEntryPriority from '../../../data/ServiceEntryPriority';
export default function ServiceEntryPriorityComponent(props) {
    var serviceEntryModel = props.serviceEntryModel, compact = props.compact;
    var priorityKey = ServiceEntryPriority.getKeyByValue(serviceEntryModel.priority);
    if (ServiceEntryPriority[priorityKey] === ServiceEntryPriority.NONE) {
        return React.createElement("span", null, "-");
    }
    return React.createElement("div", { className: "service-entry-priority-component d-flex justify-content-start align-items-center" },
        React.createElement("div", { className: 'service-entry-priority-component__color mr-3', style: { backgroundColor: ServiceEntryPriority[priorityKey].color } }),
        !compact && React.createElement(FormattedMessage, { id: 'service.entry.priority.' + priorityKey }));
}
